import { ExternalLink } from "lucide-react";
import { Empty } from "./Primitives";

const statusColor = {
  "Pending Review": "bg-amber-50 text-amber-700",
  "Missing Information": "bg-orange-50 text-orange-700",
  "Info Verified": "bg-blue-50 text-blue-700",
};

export const StuckTable = ({ stuck, onOpen }) => {
  if (!stuck.length) return <Empty text="Nothing stuck — every open claim has been touched recently" />;
  return (
    <div className="overflow-x-auto -mx-5">
      <table className="w-full text-sm" data-testid="stuck-table">
        <thead>
          <tr className="text-left text-xs uppercase tracking-wider text-gray-500 border-b border-gray-100">
            <th className="px-5 py-2 font-semibold">Claim #</th>
            <th className="px-2 py-2 font-semibold">Customer</th>
            <th className="px-2 py-2 font-semibold hidden md:table-cell">Vehicle</th>
            <th className="px-2 py-2 font-semibold">Status</th>
            <th className="px-2 py-2 font-semibold text-right">Idle</th>
            <th className="px-5 py-2"></th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {stuck.map((c, i) => (
            <tr key={c.id} className="hover:bg-gray-50" data-testid={`stuck-row-${i}`}>
              <td className="px-5 py-2 font-mono font-semibold text-gray-900">{c.claim_number}</td>
              <td className="px-2 py-2">
                <div className="text-gray-900">{c.customer_name}</div>
                <div className="text-xs text-gray-500">{c.customer_phone}</div>
              </td>
              <td className="px-2 py-2 text-gray-600 hidden md:table-cell">{c.vehicle}</td>
              <td className="px-2 py-2"><span className={`px-2 py-0.5 rounded-full text-xs font-medium ${statusColor[c.status] || "bg-gray-100 text-gray-700"}`}>{c.status}</span></td>
              <td className="px-2 py-2 text-right tabular-nums font-semibold text-red-600">{c.days_idle}d</td>
              <td className="px-5 py-2 text-right">
                <button onClick={() => onOpen(c.claim_number)} className="text-blue-600 hover:text-blue-800 inline-flex items-center gap-1 text-xs font-semibold" data-testid={`open-stuck-${i}`}>
                  Open <ExternalLink className="w-3.5 h-3.5" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const RepeatTable = ({ rows, onOpen }) => {
  if (!rows.length) return <Empty text="No repeat customers in this period" />;
  return (
    <div className="overflow-x-auto -mx-5">
      <table className="w-full text-sm" data-testid="repeat-table">
        <thead>
          <tr className="text-left text-xs uppercase tracking-wider text-gray-500 border-b border-gray-100">
            <th className="px-5 py-2 font-semibold">Customer</th>
            <th className="px-2 py-2 font-semibold text-center">Claims</th>
            <th className="px-2 py-2 font-semibold hidden md:table-cell">Vehicles</th>
            <th className="px-5 py-2"></th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {rows.map((r, i) => (
            <tr key={r.customer_phone + i} className="hover:bg-gray-50" data-testid={`repeat-row-${i}`}>
              <td className="px-5 py-2">
                <div className="text-gray-900 font-medium">{r.customer_name}</div>
                <div className="text-xs text-gray-500">{r.customer_phone}{r.customer_email ? ` · ${r.customer_email}` : ""}</div>
              </td>
              <td className="px-2 py-2 text-center"><span className="inline-flex w-7 h-7 items-center justify-center rounded-full bg-amber-100 text-amber-800 font-bold text-xs">{r.claims}</span></td>
              <td className="px-2 py-2 text-gray-600 hidden md:table-cell">{r.vehicles.join("; ")}</td>
              <td className="px-5 py-2 text-right whitespace-nowrap">
                {r.claim_numbers.map((n) => (
                  <button key={n} onClick={() => onOpen(n)} className="text-blue-600 hover:text-blue-800 font-mono text-xs font-semibold ml-2" data-testid={`open-repeat-${i}-${n}`}>#{n}</button>
                ))}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const CitiesTable = ({ cities }) => {
  if (!cities.length) return <Empty />;
  return (
    <table className="w-full text-sm" data-testid="cities-table">
      <tbody className="divide-y divide-gray-100">
        {cities.map((c, i) => (
          <tr key={c.city + c.state}>
            <td className="py-1.5 text-gray-400 w-6 tabular-nums">{i + 1}</td>
            <td className="py-1.5 text-gray-800">{c.city}<span className="text-gray-400">, {c.state}</span></td>
            <td className="py-1.5 text-right font-semibold tabular-nums">{c.count}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
